// Spherical polygon area from [{lat,lng}] rings (same approximation Turf uses).
const EARTH_RADIUS_M = 6378137
const SQM_PER_ACRE = 4046.8564224
const SQFT_PER_SQM = 10.7639104

const toRad = (deg) => (Number(deg) * Math.PI) / 180

export function ringAreaSqMeters (paths) {
  const pts = (paths || [])
    .map(p => [toRad(p.lng), toRad(p.lat)])
    .filter(([lng, lat]) => isFinite(lng) && isFinite(lat))
  if (pts.length < 3) return 0

  let sum = 0
  for (let i = 0; i < pts.length; i++) {
    const [lng1, lat1] = pts[i]
    const [lng2, lat2] = pts[(i + 1) % pts.length]
    sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2))
  }
  return Math.abs((sum * EARTH_RADIUS_M * EARTH_RADIUS_M) / 2)
}

export function totalAreaAcres (areas) {
  const sqm = (areas || []).reduce((acc, area) => acc + ringAreaSqMeters(area?.paths), 0)
  return sqm / SQM_PER_ACRE
}

export function totalAreaSqFt (areas) {
  const sqm = (areas || []).reduce((acc, area) => acc + ringAreaSqMeters(area?.paths), 0)
  return sqm * SQFT_PER_SQM
}
